import React from 'react';

const DeliveryContext = React.createContext<any>({});

export default DeliveryContext;
